import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from './commands-core'

export function useCreateCapexMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	accountId?: string | Ref<string> | (() => string), 
	isDepreciation?: boolean | Ref<boolean> | (() => boolean), 
	denomination?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	isScheduleDependent?: boolean | Ref<boolean> | (() => boolean), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _accountId = isRef<string>(accountId) ? accountId : ref<string>((typeof accountId === 'function') ? accountId() : accountId)
	const _isDepreciation = isRef<boolean>(isDepreciation) ? isDepreciation : ref<boolean>((typeof isDepreciation === 'function') ? isDepreciation() : isDepreciation)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _isScheduleDependent = isRef<boolean>(isScheduleDependent) ? isScheduleDependent : ref<boolean>((typeof isScheduleDependent === 'function') ? isScheduleDependent() : isScheduleDependent)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		accountId: _accountId,
		isDepreciation: _isDepreciation,
		denomination: _denomination,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		isScheduleDependent: _isScheduleDependent,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof accountId === 'function') { _accountId.value = accountId() }
			if (typeof isDepreciation === 'function') { _isDepreciation.value = isDepreciation() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof isScheduleDependent === 'function') { _isScheduleDependent.value = isScheduleDependent() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }

			return new c.CreateCapexMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _accountId.value, _isDepreciation.value, _denomination.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _isScheduleDependent.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value)
		})
	}

	return {
		...result,
		authorizedCreateCapexMetricCommandV1: result.authorized,
		createCapexMetricCommandV1: result.command,
		completedCreateCapexMetricCommandV1: result.completed,
		errorCreateCapexMetricCommandV1: result.error,
		invokeCreateCapexMetricCommandV1: result.invoke,
		invokingCreateCapexMetricCommandV1: result.invoking,
		succeedCreateCapexMetricCommandV1: result.succeed,
		validationErrorsCreateCapexMetricCommandV1: result.validationErrors,
		onSucceedCreateCapexMetricCommandV1: result.onSucceed,
	}
}

export function useCreateCostSubtotalMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	subtotalId?: string | Ref<string> | (() => string), 
	valueBalanceType?: any | Ref<any> | (() => any), 
	denomination?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _subtotalId = isRef<string>(subtotalId) ? subtotalId : ref<string>((typeof subtotalId === 'function') ? subtotalId() : subtotalId)
	const _valueBalanceType = isRef<any>(valueBalanceType) ? valueBalanceType : ref<any>((typeof valueBalanceType === 'function') ? valueBalanceType() : valueBalanceType)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		subtotalId: _subtotalId,
		valueBalanceType: _valueBalanceType,
		denomination: _denomination,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof subtotalId === 'function') { _subtotalId.value = subtotalId() }
			if (typeof valueBalanceType === 'function') { _valueBalanceType.value = valueBalanceType() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }

			return new c.CreateCostSubtotalMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _subtotalId.value, _valueBalanceType.value, _denomination.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value, _applyBenefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedCreateCostSubtotalMetricCommandV1: result.authorized,
		createCostSubtotalMetricCommandV1: result.command,
		completedCreateCostSubtotalMetricCommandV1: result.completed,
		errorCreateCostSubtotalMetricCommandV1: result.error,
		invokeCreateCostSubtotalMetricCommandV1: result.invoke,
		invokingCreateCostSubtotalMetricCommandV1: result.invoking,
		succeedCreateCostSubtotalMetricCommandV1: result.succeed,
		validationErrorsCreateCostSubtotalMetricCommandV1: result.validationErrors,
		onSucceedCreateCostSubtotalMetricCommandV1: result.onSucceed,
	}
}

export function useCreateExpenseMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	expenseAccountId?: string | Ref<string> | (() => string), 
	valueBalanceType?: any | Ref<any> | (() => any), 
	denomination?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	isScheduleDependent?: boolean | Ref<boolean> | (() => boolean), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _expenseAccountId = isRef<string>(expenseAccountId) ? expenseAccountId : ref<string>((typeof expenseAccountId === 'function') ? expenseAccountId() : expenseAccountId)
	const _valueBalanceType = isRef<any>(valueBalanceType) ? valueBalanceType : ref<any>((typeof valueBalanceType === 'function') ? valueBalanceType() : valueBalanceType)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _isScheduleDependent = isRef<boolean>(isScheduleDependent) ? isScheduleDependent : ref<boolean>((typeof isScheduleDependent === 'function') ? isScheduleDependent() : isScheduleDependent)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		expenseAccountId: _expenseAccountId,
		valueBalanceType: _valueBalanceType,
		denomination: _denomination,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		isScheduleDependent: _isScheduleDependent,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof expenseAccountId === 'function') { _expenseAccountId.value = expenseAccountId() }
			if (typeof valueBalanceType === 'function') { _valueBalanceType.value = valueBalanceType() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof isScheduleDependent === 'function') { _isScheduleDependent.value = isScheduleDependent() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }

			return new c.CreateExpenseMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _expenseAccountId.value, _valueBalanceType.value, _denomination.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _isScheduleDependent.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value, _applyBenefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedCreateExpenseMetricCommandV1: result.authorized,
		createExpenseMetricCommandV1: result.command,
		completedCreateExpenseMetricCommandV1: result.completed,
		errorCreateExpenseMetricCommandV1: result.error,
		invokeCreateExpenseMetricCommandV1: result.invoke,
		invokingCreateExpenseMetricCommandV1: result.invoking,
		succeedCreateExpenseMetricCommandV1: result.succeed,
		validationErrorsCreateExpenseMetricCommandV1: result.validationErrors,
		onSucceedCreateExpenseMetricCommandV1: result.onSucceed,
	}
}

export function useCreateMarginCogsMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	revenueId?: string | Ref<string> | (() => string), 
	denomination?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	isScheduleDependent?: boolean | Ref<boolean> | (() => boolean), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _revenueId = isRef<string>(revenueId) ? revenueId : ref<string>((typeof revenueId === 'function') ? revenueId() : revenueId)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _isScheduleDependent = isRef<boolean>(isScheduleDependent) ? isScheduleDependent : ref<boolean>((typeof isScheduleDependent === 'function') ? isScheduleDependent() : isScheduleDependent)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		revenueId: _revenueId,
		denomination: _denomination,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		isScheduleDependent: _isScheduleDependent,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof revenueId === 'function') { _revenueId.value = revenueId() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof isScheduleDependent === 'function') { _isScheduleDependent.value = isScheduleDependent() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }

			return new c.CreateMarginCogsMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _revenueId.value, _denomination.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _isScheduleDependent.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value, _applyBenefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedCreateMarginCogsMetricCommandV1: result.authorized,
		createMarginCogsMetricCommandV1: result.command,
		completedCreateMarginCogsMetricCommandV1: result.completed,
		errorCreateMarginCogsMetricCommandV1: result.error,
		invokeCreateMarginCogsMetricCommandV1: result.invoke,
		invokingCreateMarginCogsMetricCommandV1: result.invoking,
		succeedCreateMarginCogsMetricCommandV1: result.succeed,
		validationErrorsCreateMarginCogsMetricCommandV1: result.validationErrors,
		onSucceedCreateMarginCogsMetricCommandV1: result.onSucceed,
	}
}

export function useCreateOpexMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	costIds?: any | Ref<any> | (() => any), 
	valueBalanceType?: any | Ref<any> | (() => any), 
	denomination?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _costIds = isRef<any>(costIds) ? costIds : ref<any>((typeof costIds === 'function') ? costIds() : costIds)
	const _valueBalanceType = isRef<any>(valueBalanceType) ? valueBalanceType : ref<any>((typeof valueBalanceType === 'function') ? valueBalanceType() : valueBalanceType)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		costIds: _costIds,
		valueBalanceType: _valueBalanceType,
		denomination: _denomination,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof costIds === 'function') { _costIds.value = costIds() }
			if (typeof valueBalanceType === 'function') { _valueBalanceType.value = valueBalanceType() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }

			return new c.CreateOpexMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _costIds.value, _valueBalanceType.value, _denomination.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value, _applyBenefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedCreateOpexMetricCommandV1: result.authorized,
		createOpexMetricCommandV1: result.command,
		completedCreateOpexMetricCommandV1: result.completed,
		errorCreateOpexMetricCommandV1: result.error,
		invokeCreateOpexMetricCommandV1: result.invoke,
		invokingCreateOpexMetricCommandV1: result.invoking,
		succeedCreateOpexMetricCommandV1: result.succeed,
		validationErrorsCreateOpexMetricCommandV1: result.validationErrors,
		onSucceedCreateOpexMetricCommandV1: result.onSucceed,
	}
}

export function useCreateResourceCostMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	resourceId?: string | Ref<string> | (() => string), 
	valueBalanceType?: any | Ref<any> | (() => any), 
	denomination?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _resourceId = isRef<string>(resourceId) ? resourceId : ref<string>((typeof resourceId === 'function') ? resourceId() : resourceId)
	const _valueBalanceType = isRef<any>(valueBalanceType) ? valueBalanceType : ref<any>((typeof valueBalanceType === 'function') ? valueBalanceType() : valueBalanceType)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		resourceId: _resourceId,
		valueBalanceType: _valueBalanceType,
		denomination: _denomination,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof resourceId === 'function') { _resourceId.value = resourceId() }
			if (typeof valueBalanceType === 'function') { _valueBalanceType.value = valueBalanceType() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }

			return new c.CreateResourceCostMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _resourceId.value, _valueBalanceType.value, _denomination.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value, _applyBenefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedCreateResourceCostMetricCommandV1: result.authorized,
		createResourceCostMetricCommandV1: result.command,
		completedCreateResourceCostMetricCommandV1: result.completed,
		errorCreateResourceCostMetricCommandV1: result.error,
		invokeCreateResourceCostMetricCommandV1: result.invoke,
		invokingCreateResourceCostMetricCommandV1: result.invoking,
		succeedCreateResourceCostMetricCommandV1: result.succeed,
		validationErrorsCreateResourceCostMetricCommandV1: result.validationErrors,
		onSucceedCreateResourceCostMetricCommandV1: result.onSucceed,
	}
}

export function useCreateResourceMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	resourceId?: string | Ref<string> | (() => string), 
	valueBalanceType?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	isScheduleDependent?: boolean | Ref<boolean> | (() => boolean), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _resourceId = isRef<string>(resourceId) ? resourceId : ref<string>((typeof resourceId === 'function') ? resourceId() : resourceId)
	const _valueBalanceType = isRef<any>(valueBalanceType) ? valueBalanceType : ref<any>((typeof valueBalanceType === 'function') ? valueBalanceType() : valueBalanceType)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _isScheduleDependent = isRef<boolean>(isScheduleDependent) ? isScheduleDependent : ref<boolean>((typeof isScheduleDependent === 'function') ? isScheduleDependent() : isScheduleDependent)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		resourceId: _resourceId,
		valueBalanceType: _valueBalanceType,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		isScheduleDependent: _isScheduleDependent,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof resourceId === 'function') { _resourceId.value = resourceId() }
			if (typeof valueBalanceType === 'function') { _valueBalanceType.value = valueBalanceType() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof isScheduleDependent === 'function') { _isScheduleDependent.value = isScheduleDependent() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }

			return new c.CreateResourceMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _resourceId.value, _valueBalanceType.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _isScheduleDependent.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value, _applyBenefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedCreateResourceMetricCommandV1: result.authorized,
		createResourceMetricCommandV1: result.command,
		completedCreateResourceMetricCommandV1: result.completed,
		errorCreateResourceMetricCommandV1: result.error,
		invokeCreateResourceMetricCommandV1: result.invoke,
		invokingCreateResourceMetricCommandV1: result.invoking,
		succeedCreateResourceMetricCommandV1: result.succeed,
		validationErrorsCreateResourceMetricCommandV1: result.validationErrors,
		onSucceedCreateResourceMetricCommandV1: result.onSucceed,
	}
}

export function useCreateRevenueMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	revenueId?: string | Ref<string> | (() => string), 
	denomination?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	isScheduleDependent?: boolean | Ref<boolean> | (() => boolean), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _revenueId = isRef<string>(revenueId) ? revenueId : ref<string>((typeof revenueId === 'function') ? revenueId() : revenueId)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _isScheduleDependent = isRef<boolean>(isScheduleDependent) ? isScheduleDependent : ref<boolean>((typeof isScheduleDependent === 'function') ? isScheduleDependent() : isScheduleDependent)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		revenueId: _revenueId,
		denomination: _denomination,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		isScheduleDependent: _isScheduleDependent,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof revenueId === 'function') { _revenueId.value = revenueId() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof isScheduleDependent === 'function') { _isScheduleDependent.value = isScheduleDependent() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }

			return new c.CreateRevenueMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _revenueId.value, _denomination.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _isScheduleDependent.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value, _applyBenefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedCreateRevenueMetricCommandV1: result.authorized,
		createRevenueMetricCommandV1: result.command,
		completedCreateRevenueMetricCommandV1: result.completed,
		errorCreateRevenueMetricCommandV1: result.error,
		invokeCreateRevenueMetricCommandV1: result.invoke,
		invokingCreateRevenueMetricCommandV1: result.invoking,
		succeedCreateRevenueMetricCommandV1: result.succeed,
		validationErrorsCreateRevenueMetricCommandV1: result.validationErrors,
		onSucceedCreateRevenueMetricCommandV1: result.onSucceed,
	}
}

export function useCreateTotalCostMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	revenueId?: string | Ref<string> | (() => string), 
	denomination?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _revenueId = isRef<string>(revenueId) ? revenueId : ref<string>((typeof revenueId === 'function') ? revenueId() : revenueId)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		revenueId: _revenueId,
		denomination: _denomination,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof revenueId === 'function') { _revenueId.value = revenueId() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }

			return new c.CreateTotalCostMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _revenueId.value, _denomination.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value, _applyBenefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedCreateTotalCostMetricCommandV1: result.authorized,
		createTotalCostMetricCommandV1: result.command,
		completedCreateTotalCostMetricCommandV1: result.completed,
		errorCreateTotalCostMetricCommandV1: result.error,
		invokeCreateTotalCostMetricCommandV1: result.invoke,
		invokingCreateTotalCostMetricCommandV1: result.invoking,
		succeedCreateTotalCostMetricCommandV1: result.succeed,
		validationErrorsCreateTotalCostMetricCommandV1: result.validationErrors,
		onSucceedCreateTotalCostMetricCommandV1: result.onSucceed,
	}
}

export function useDeleteMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.DeleteMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedDeleteMetricCommandV1: result.authorized,
		deleteMetricCommandV1: result.command,
		completedDeleteMetricCommandV1: result.completed,
		errorDeleteMetricCommandV1: result.error,
		invokeDeleteMetricCommandV1: result.invoke,
		invokingDeleteMetricCommandV1: result.invoking,
		succeedDeleteMetricCommandV1: result.succeed,
		validationErrorsDeleteMetricCommandV1: result.validationErrors,
		onSucceedDeleteMetricCommandV1: result.onSucceed,
	}
}

export function useUpdateCapexMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	accountId?: string | Ref<string> | (() => string), 
	isDepreciation?: boolean | Ref<boolean> | (() => boolean), 
	denomination?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	isScheduleDependent?: boolean | Ref<boolean> | (() => boolean), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _accountId = isRef<string>(accountId) ? accountId : ref<string>((typeof accountId === 'function') ? accountId() : accountId)
	const _isDepreciation = isRef<boolean>(isDepreciation) ? isDepreciation : ref<boolean>((typeof isDepreciation === 'function') ? isDepreciation() : isDepreciation)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _isScheduleDependent = isRef<boolean>(isScheduleDependent) ? isScheduleDependent : ref<boolean>((typeof isScheduleDependent === 'function') ? isScheduleDependent() : isScheduleDependent)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		accountId: _accountId,
		isDepreciation: _isDepreciation,
		denomination: _denomination,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		isScheduleDependent: _isScheduleDependent,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof accountId === 'function') { _accountId.value = accountId() }
			if (typeof isDepreciation === 'function') { _isDepreciation.value = isDepreciation() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof isScheduleDependent === 'function') { _isScheduleDependent.value = isScheduleDependent() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }

			return new c.UpdateCapexMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _accountId.value, _isDepreciation.value, _denomination.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _isScheduleDependent.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value)
		})
	}

	return {
		...result,
		authorizedUpdateCapexMetricCommandV1: result.authorized,
		updateCapexMetricCommandV1: result.command,
		completedUpdateCapexMetricCommandV1: result.completed,
		errorUpdateCapexMetricCommandV1: result.error,
		invokeUpdateCapexMetricCommandV1: result.invoke,
		invokingUpdateCapexMetricCommandV1: result.invoking,
		succeedUpdateCapexMetricCommandV1: result.succeed,
		validationErrorsUpdateCapexMetricCommandV1: result.validationErrors,
		onSucceedUpdateCapexMetricCommandV1: result.onSucceed,
	}
}

export function useUpdateCostSubtotalMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	subtotalId?: string | Ref<string> | (() => string), 
	valueBalanceType?: any | Ref<any> | (() => any), 
	denomination?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _subtotalId = isRef<string>(subtotalId) ? subtotalId : ref<string>((typeof subtotalId === 'function') ? subtotalId() : subtotalId)
	const _valueBalanceType = isRef<any>(valueBalanceType) ? valueBalanceType : ref<any>((typeof valueBalanceType === 'function') ? valueBalanceType() : valueBalanceType)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		subtotalId: _subtotalId,
		valueBalanceType: _valueBalanceType,
		denomination: _denomination,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof subtotalId === 'function') { _subtotalId.value = subtotalId() }
			if (typeof valueBalanceType === 'function') { _valueBalanceType.value = valueBalanceType() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }

			return new c.UpdateCostSubtotalMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _subtotalId.value, _valueBalanceType.value, _denomination.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value, _applyBenefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedUpdateCostSubtotalMetricCommandV1: result.authorized,
		updateCostSubtotalMetricCommandV1: result.command,
		completedUpdateCostSubtotalMetricCommandV1: result.completed,
		errorUpdateCostSubtotalMetricCommandV1: result.error,
		invokeUpdateCostSubtotalMetricCommandV1: result.invoke,
		invokingUpdateCostSubtotalMetricCommandV1: result.invoking,
		succeedUpdateCostSubtotalMetricCommandV1: result.succeed,
		validationErrorsUpdateCostSubtotalMetricCommandV1: result.validationErrors,
		onSucceedUpdateCostSubtotalMetricCommandV1: result.onSucceed,
	}
}

export function useUpdateExpenseMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	expenseAccountId?: string | Ref<string> | (() => string), 
	valueBalanceType?: any | Ref<any> | (() => any), 
	denomination?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	isScheduleDependent?: boolean | Ref<boolean> | (() => boolean), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _expenseAccountId = isRef<string>(expenseAccountId) ? expenseAccountId : ref<string>((typeof expenseAccountId === 'function') ? expenseAccountId() : expenseAccountId)
	const _valueBalanceType = isRef<any>(valueBalanceType) ? valueBalanceType : ref<any>((typeof valueBalanceType === 'function') ? valueBalanceType() : valueBalanceType)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _isScheduleDependent = isRef<boolean>(isScheduleDependent) ? isScheduleDependent : ref<boolean>((typeof isScheduleDependent === 'function') ? isScheduleDependent() : isScheduleDependent)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		expenseAccountId: _expenseAccountId,
		valueBalanceType: _valueBalanceType,
		denomination: _denomination,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		isScheduleDependent: _isScheduleDependent,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof expenseAccountId === 'function') { _expenseAccountId.value = expenseAccountId() }
			if (typeof valueBalanceType === 'function') { _valueBalanceType.value = valueBalanceType() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof isScheduleDependent === 'function') { _isScheduleDependent.value = isScheduleDependent() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }

			return new c.UpdateExpenseMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _expenseAccountId.value, _valueBalanceType.value, _denomination.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _isScheduleDependent.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value, _applyBenefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedUpdateExpenseMetricCommandV1: result.authorized,
		updateExpenseMetricCommandV1: result.command,
		completedUpdateExpenseMetricCommandV1: result.completed,
		errorUpdateExpenseMetricCommandV1: result.error,
		invokeUpdateExpenseMetricCommandV1: result.invoke,
		invokingUpdateExpenseMetricCommandV1: result.invoking,
		succeedUpdateExpenseMetricCommandV1: result.succeed,
		validationErrorsUpdateExpenseMetricCommandV1: result.validationErrors,
		onSucceedUpdateExpenseMetricCommandV1: result.onSucceed,
	}
}

export function useUpdateMarginCogsMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	revenueId?: string | Ref<string> | (() => string), 
	denomination?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	isScheduleDependent?: boolean | Ref<boolean> | (() => boolean), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _revenueId = isRef<string>(revenueId) ? revenueId : ref<string>((typeof revenueId === 'function') ? revenueId() : revenueId)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _isScheduleDependent = isRef<boolean>(isScheduleDependent) ? isScheduleDependent : ref<boolean>((typeof isScheduleDependent === 'function') ? isScheduleDependent() : isScheduleDependent)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		revenueId: _revenueId,
		denomination: _denomination,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		isScheduleDependent: _isScheduleDependent,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof revenueId === 'function') { _revenueId.value = revenueId() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof isScheduleDependent === 'function') { _isScheduleDependent.value = isScheduleDependent() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }

			return new c.UpdateMarginCogsMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _revenueId.value, _denomination.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _isScheduleDependent.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value, _applyBenefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedUpdateMarginCogsMetricCommandV1: result.authorized,
		updateMarginCogsMetricCommandV1: result.command,
		completedUpdateMarginCogsMetricCommandV1: result.completed,
		errorUpdateMarginCogsMetricCommandV1: result.error,
		invokeUpdateMarginCogsMetricCommandV1: result.invoke,
		invokingUpdateMarginCogsMetricCommandV1: result.invoking,
		succeedUpdateMarginCogsMetricCommandV1: result.succeed,
		validationErrorsUpdateMarginCogsMetricCommandV1: result.validationErrors,
		onSucceedUpdateMarginCogsMetricCommandV1: result.onSucceed,
	}
}

export function useUpdateOpexMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	costIds?: any | Ref<any> | (() => any), 
	valueBalanceType?: any | Ref<any> | (() => any), 
	denomination?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _costIds = isRef<any>(costIds) ? costIds : ref<any>((typeof costIds === 'function') ? costIds() : costIds)
	const _valueBalanceType = isRef<any>(valueBalanceType) ? valueBalanceType : ref<any>((typeof valueBalanceType === 'function') ? valueBalanceType() : valueBalanceType)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		costIds: _costIds,
		valueBalanceType: _valueBalanceType,
		denomination: _denomination,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof costIds === 'function') { _costIds.value = costIds() }
			if (typeof valueBalanceType === 'function') { _valueBalanceType.value = valueBalanceType() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }

			return new c.UpdateOpexMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _costIds.value, _valueBalanceType.value, _denomination.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value, _applyBenefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedUpdateOpexMetricCommandV1: result.authorized,
		updateOpexMetricCommandV1: result.command,
		completedUpdateOpexMetricCommandV1: result.completed,
		errorUpdateOpexMetricCommandV1: result.error,
		invokeUpdateOpexMetricCommandV1: result.invoke,
		invokingUpdateOpexMetricCommandV1: result.invoking,
		succeedUpdateOpexMetricCommandV1: result.succeed,
		validationErrorsUpdateOpexMetricCommandV1: result.validationErrors,
		onSucceedUpdateOpexMetricCommandV1: result.onSucceed,
	}
}

export function useUpdateResourceCostMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	resourceId?: string | Ref<string> | (() => string), 
	valueBalanceType?: any | Ref<any> | (() => any), 
	denomination?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _resourceId = isRef<string>(resourceId) ? resourceId : ref<string>((typeof resourceId === 'function') ? resourceId() : resourceId)
	const _valueBalanceType = isRef<any>(valueBalanceType) ? valueBalanceType : ref<any>((typeof valueBalanceType === 'function') ? valueBalanceType() : valueBalanceType)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		resourceId: _resourceId,
		valueBalanceType: _valueBalanceType,
		denomination: _denomination,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof resourceId === 'function') { _resourceId.value = resourceId() }
			if (typeof valueBalanceType === 'function') { _valueBalanceType.value = valueBalanceType() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }

			return new c.UpdateResourceCostMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _resourceId.value, _valueBalanceType.value, _denomination.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value, _applyBenefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedUpdateResourceCostMetricCommandV1: result.authorized,
		updateResourceCostMetricCommandV1: result.command,
		completedUpdateResourceCostMetricCommandV1: result.completed,
		errorUpdateResourceCostMetricCommandV1: result.error,
		invokeUpdateResourceCostMetricCommandV1: result.invoke,
		invokingUpdateResourceCostMetricCommandV1: result.invoking,
		succeedUpdateResourceCostMetricCommandV1: result.succeed,
		validationErrorsUpdateResourceCostMetricCommandV1: result.validationErrors,
		onSucceedUpdateResourceCostMetricCommandV1: result.onSucceed,
	}
}

export function useUpdateResourceMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	resourceId?: string | Ref<string> | (() => string), 
	valueBalanceType?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	isScheduleDependent?: boolean | Ref<boolean> | (() => boolean), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _resourceId = isRef<string>(resourceId) ? resourceId : ref<string>((typeof resourceId === 'function') ? resourceId() : resourceId)
	const _valueBalanceType = isRef<any>(valueBalanceType) ? valueBalanceType : ref<any>((typeof valueBalanceType === 'function') ? valueBalanceType() : valueBalanceType)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _isScheduleDependent = isRef<boolean>(isScheduleDependent) ? isScheduleDependent : ref<boolean>((typeof isScheduleDependent === 'function') ? isScheduleDependent() : isScheduleDependent)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		resourceId: _resourceId,
		valueBalanceType: _valueBalanceType,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		isScheduleDependent: _isScheduleDependent,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof resourceId === 'function') { _resourceId.value = resourceId() }
			if (typeof valueBalanceType === 'function') { _valueBalanceType.value = valueBalanceType() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof isScheduleDependent === 'function') { _isScheduleDependent.value = isScheduleDependent() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }

			return new c.UpdateResourceMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _resourceId.value, _valueBalanceType.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _isScheduleDependent.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value, _applyBenefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedUpdateResourceMetricCommandV1: result.authorized,
		updateResourceMetricCommandV1: result.command,
		completedUpdateResourceMetricCommandV1: result.completed,
		errorUpdateResourceMetricCommandV1: result.error,
		invokeUpdateResourceMetricCommandV1: result.invoke,
		invokingUpdateResourceMetricCommandV1: result.invoking,
		succeedUpdateResourceMetricCommandV1: result.succeed,
		validationErrorsUpdateResourceMetricCommandV1: result.validationErrors,
		onSucceedUpdateResourceMetricCommandV1: result.onSucceed,
	}
}

export function useUpdateRevenueMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	revenueId?: string | Ref<string> | (() => string), 
	denomination?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	isScheduleDependent?: boolean | Ref<boolean> | (() => boolean), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _revenueId = isRef<string>(revenueId) ? revenueId : ref<string>((typeof revenueId === 'function') ? revenueId() : revenueId)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _isScheduleDependent = isRef<boolean>(isScheduleDependent) ? isScheduleDependent : ref<boolean>((typeof isScheduleDependent === 'function') ? isScheduleDependent() : isScheduleDependent)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		revenueId: _revenueId,
		denomination: _denomination,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		isScheduleDependent: _isScheduleDependent,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof revenueId === 'function') { _revenueId.value = revenueId() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof isScheduleDependent === 'function') { _isScheduleDependent.value = isScheduleDependent() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }

			return new c.UpdateRevenueMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _revenueId.value, _denomination.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _isScheduleDependent.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value, _applyBenefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedUpdateRevenueMetricCommandV1: result.authorized,
		updateRevenueMetricCommandV1: result.command,
		completedUpdateRevenueMetricCommandV1: result.completed,
		errorUpdateRevenueMetricCommandV1: result.error,
		invokeUpdateRevenueMetricCommandV1: result.invoke,
		invokingUpdateRevenueMetricCommandV1: result.invoking,
		succeedUpdateRevenueMetricCommandV1: result.succeed,
		validationErrorsUpdateRevenueMetricCommandV1: result.validationErrors,
		onSucceedUpdateRevenueMetricCommandV1: result.onSucceed,
	}
}

export function useUpdateTotalCostMetricCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	denomination?: any | Ref<any> | (() => any), 
	windowStartOffsetInMonths?: number | null | Ref<number | null> | (() => number | null), 
	windowLengthInMonths?: number | null | Ref<number | null> | (() => number | null), 
	defaultProjectStartDate?: any | null | Ref<any | null> | (() => any | null), 
	startDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	endDateBoundary?: any | null | Ref<any | null> | (() => any | null), 
	valueCommitmentType?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _windowStartOffsetInMonths = isRef<number | null>(windowStartOffsetInMonths) ? windowStartOffsetInMonths : ref<number | null>((typeof windowStartOffsetInMonths === 'function') ? windowStartOffsetInMonths() : windowStartOffsetInMonths)
	const _windowLengthInMonths = isRef<number | null>(windowLengthInMonths) ? windowLengthInMonths : ref<number | null>((typeof windowLengthInMonths === 'function') ? windowLengthInMonths() : windowLengthInMonths)
	const _defaultProjectStartDate = isRef<any | null>(defaultProjectStartDate) ? defaultProjectStartDate : ref<any | null>((typeof defaultProjectStartDate === 'function') ? defaultProjectStartDate() : defaultProjectStartDate)
	const _startDateBoundary = isRef<any | null>(startDateBoundary) ? startDateBoundary : ref<any | null>((typeof startDateBoundary === 'function') ? startDateBoundary() : startDateBoundary)
	const _endDateBoundary = isRef<any | null>(endDateBoundary) ? endDateBoundary : ref<any | null>((typeof endDateBoundary === 'function') ? endDateBoundary() : endDateBoundary)
	const _valueCommitmentType = isRef<any>(valueCommitmentType) ? valueCommitmentType : ref<any>((typeof valueCommitmentType === 'function') ? valueCommitmentType() : valueCommitmentType)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		denomination: _denomination,
		windowStartOffsetInMonths: _windowStartOffsetInMonths,
		windowLengthInMonths: _windowLengthInMonths,
		defaultProjectStartDate: _defaultProjectStartDate,
		startDateBoundary: _startDateBoundary,
		endDateBoundary: _endDateBoundary,
		valueCommitmentType: _valueCommitmentType,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof windowStartOffsetInMonths === 'function') { _windowStartOffsetInMonths.value = windowStartOffsetInMonths() }
			if (typeof windowLengthInMonths === 'function') { _windowLengthInMonths.value = windowLengthInMonths() }
			if (typeof defaultProjectStartDate === 'function') { _defaultProjectStartDate.value = defaultProjectStartDate() }
			if (typeof startDateBoundary === 'function') { _startDateBoundary.value = startDateBoundary() }
			if (typeof endDateBoundary === 'function') { _endDateBoundary.value = endDateBoundary() }
			if (typeof valueCommitmentType === 'function') { _valueCommitmentType.value = valueCommitmentType() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }

			return new c.UpdateTotalCostMetricCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _denomination.value, _windowStartOffsetInMonths.value, _windowLengthInMonths.value, _defaultProjectStartDate.value, _startDateBoundary.value, _endDateBoundary.value, _valueCommitmentType.value, _applyBenefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedUpdateTotalCostMetricCommandV1: result.authorized,
		updateTotalCostMetricCommandV1: result.command,
		completedUpdateTotalCostMetricCommandV1: result.completed,
		errorUpdateTotalCostMetricCommandV1: result.error,
		invokeUpdateTotalCostMetricCommandV1: result.invoke,
		invokingUpdateTotalCostMetricCommandV1: result.invoking,
		succeedUpdateTotalCostMetricCommandV1: result.succeed,
		validationErrorsUpdateTotalCostMetricCommandV1: result.validationErrors,
		onSucceedUpdateTotalCostMetricCommandV1: result.onSucceed,
	}
}

